/**
 * pharmacy-cart-bypass.js — mecindo.dk
 *
 * Bypasses the power-step modal and opens the cart drawer instead for:
 *   1. Products tagged "PIM_pharmacy" (data-pharmacy="true")
 *   2. OTC medicine products with active-ingredient restrictions (data-meds-check)
 *
 * How it works:
 *   Liquid stamps data-pharmacy="true" and/or data-meds-check="<groups>"
 *   on every <product-form> whose product matches the criteria
 *   (see product-card.liquid & main-product.liquid).
 *
 *   The power-step listens to 'on:cart:add' in the bubble phase.
 *   We register a CAPTURE phase listener that runs first. If the dispatching
 *   product-form matches, we stopImmediatePropagation() so the power-step
 *   never fires, then open the cart drawer ourselves.
 *
 *   This is synchronous — no async/await, no race conditions.
 */

(function () {
  'use strict';

  document.addEventListener(
    'on:cart:add',
    function (evt) {
      // Only intercept when power-step is the active after-ATC behaviour.
      if (window.theme?.settings?.afterAtc !== 'power-step') return;

      // The event is dispatched via this.dispatchEvent() on the <product-form>
      // element, so evt.target is the product-form itself.
      const form = evt.target?.closest?.('product-form') || evt.target;

      const shouldBypass =
        // PIM_pharmacy products
        form?.dataset?.pharmacy === 'true' ||
        // OTC medicine products with active-ingredient restrictions
        !!form?.dataset?.medsCheck;

      if (!shouldBypass) return;

      // Stop the power-step from receiving this event.
      evt.stopImmediatePropagation();

      // Refresh drawer contents so the new item appears, then open it.
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
      );
      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })
        );
      }, 100);
    },
    true // capture phase — runs before all bubble-phase listeners
  );
})();
